const mensajes = {
    // CampoCodigoDocumentoBase
    'DocumentoBuscador.CampoCodigoDocumentoBase.Nombre': 'Base document code',
};

export default mensajes;
